import { render, staticRenderFns } from "./EventsTeaser.vue?vue&type=template&id=54d1b8c4&"
import script from "./EventsTeaser.vue?vue&type=script&lang=js&"
export * from "./EventsTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports